import React from 'react';

interface Props {
    className?: string;
}

export const CoachScholar: React.FC<Props> = ({ className }) => {
    return (
        <svg
            className={`icon${className ? ` ${className}` : ''}`}
            width="138.838"
            height="181.126"
            viewBox="0 0 138.838 181.126"
        >
            <g id="Group_37" data-name="Group 37" className="cls-2" transform="translate(0)">
                <path
                    id="Path_11"
                    data-name="Path 11"
                    className="cls-3"
                    d="M105,239.4c-.275,0-.55.011-.829.034a9.9,9.9,0,1,0,3.954,19.246v11.449h3.824a2.94,2.94,0,0,0,2.939-2.948l-.048-18.927A9.9,9.9,0,0,0,105,239.4"
                    transform="translate(-35.359 -89.003)"
                />
                <path
                    id="Path_12"
                    data-name="Path 12"
                    className="cls-1"
                    d="M111.965,168.436H26.872A26.871,26.871,0,0,0,0,195.308v31.35H54.561a15.666,15.666,0,0,1-.37-5.493,15.38,15.38,0,0,1,1.245-4.558H10.052v-21.3a16.839,16.839,0,0,1,16.82-16.82h11.86c11.311,15.742,30.909,32.305,30.909,32.305s19.6-16.563,30.909-32.305h11.415a16.839,16.839,0,0,1,16.821,16.82v21.3H83.852a15.567,15.567,0,0,1,1.255,4.677l.03.286v.288l.013,4.8h53.687v-31.35a26.872,26.872,0,0,0-26.872-26.872M69.641,199.892a217.987,217.987,0,0,1-20.6-21.4H90.244a218.133,218.133,0,0,1-20.6,21.4"
                    transform="translate(0 -62.62)"
                />
                <path
                    id="Path_13"
                    data-name="Path 13"
                    className="cls-1"
                    d="M121.241,45.166h7.429a20.645,20.645,0,0,0-5.057-5.812c0-.1.007-.193.007-.292a39.063,39.063,0,0,0-78.125,0c0,.187.009.371.014.556a20.36,20.36,0,0,0-4.745,5.548h7.742a38.95,38.95,0,1,0,72.136,0ZM84.557,11.208A27.9,27.9,0,0,1,111.706,32.85,78.916,78.916,0,0,0,84.717,28.4a78.621,78.621,0,0,0-27.335,4.582,27.9,27.9,0,0,1,27.175-21.77m.016,77.559a28.87,28.87,0,0,1-23.952-45.03A67.279,67.279,0,0,1,84.717,39.6a67.662,67.662,0,0,1,23.708,3.989A28.868,28.868,0,0,1,84.574,88.767"
                    transform="translate(-15.155)"
                />
            </g>
        </svg>
    );
};
